<template>
  <div class="UsLicenses-container">
    <div class="title-content">
      <img src="./../assets/image/licenses-icon.png" class="title-logo" @click="goHome" />
    </div>
    <div class="title-us">
      <div class="us-text">Privacy Notice</div>
    </div>
    <div class="state-content">
      <div class="state-title">Gramm–Leach–Bliley Act (GLBA) Privacy Notice</div>
      <div class="state-text-box">
        <div class="text-title text-bold">
          <div>Original Effective Date: September 1, 2025</div>
          <div>Last Updated: July 16, 2026</div>
        </div>

        <div class="sub-title">Pre-Operational Notice</div>
        <div>
          Alchemy Pay, Inc. is currently pre-operational and does not accept customer applications, open customer accounts, process customer transactions, or provide money
          transmission, on-ramp, off-ramp, or other digital financial asset services in the United States, including California.
        </div>
        <div>
          The descriptions below apply to information that Alchemy Pay, Inc. may collect, use, and disclose if and when it begins offering financial services, as well as limited
          information that may currently be collected through this website and corporate or other business inquiries. Any future financial services will be subject to applicable
          licensing, regulatory approvals, eligibility requirements, and geographic restrictions.
        </div>
        <div>
          This notice describes how Alchemy Pay, Inc. (“Company,” “we,” “our,” or “us”) collects, uses, discloses, and protects nonpublic personal information in accordance with
          the federal Gramm–Leach–Bliley Act (“GLBA”) and other applicable privacy laws.
        </div>

        <div class="sub-title">Information We Collect</div>
        <div>
          We may currently collect limited information submitted through this website or our inquiry channels, including your name, business contact information, company
          affiliation, the content of your inquiry, IP address, browser information, and website usage information.
        </div>
        <div>If and when financial services are offered, we may also collect:</div>
        <div class="pl8">- Identifying information, including name, address, email address, telephone number, and date of birth.</div>
        <div class="pl8">- Government identification information, including driver’s license, passport, and taxpayer identification number.</div>
        <div class="pl8">- Financial information, including bank account details, payment card information, wallet information, and transaction history.</div>
        <div class="pl8">
          - Compliance information used for identity verification, sanctions screening, fraud prevention, anti-money laundering reviews, and other legal or regulatory requirements.
        </div>
        <div class="pl8">- Device, account, and online identifiers, including IP address, browser information, login information, and device identifiers.</div>

        <div class="sub-title">How We Use Information</div>
        <div>We may currently use information to:</div>
        <div class="pl8">- Respond to corporate, regulatory, licensing, vendor, partnership, employment, and other business inquiries.</div>
        <div class="pl8">- Evaluate proposed business relationships.</div>
        <div class="pl8">- Operate, secure, and improve this website.</div>
        <div class="pl8">- Maintain business, legal, compliance, and regulatory records.</div>
        <div class="pl8">- Protect against fraud, misuse, and unauthorized access.</div>
        <div>If and when financial services are offered, we may also use information to:</div>
        <div class="pl8">- Review applications and establish customer accounts.</div>
        <div class="pl8">- Provide on-ramp, off-ramp, money transmission, or other financial services.</div>
        <div class="pl8">- Verify identity and comply with anti-money laundering, sanctions, and other legal or regulatory obligations.</div>
        <div class="pl8">- Process, record, settle, and monitor transactions.</div>
        <div class="pl8">- Provide customer support and investigate complaints, disputes, errors, and unauthorized transactions.</div>
        <div class="pl8">- Protect against fraud, security threats, and misuse of services.</div>

        <div class="sub-title">How We Disclose Information</div>
        <div>We do not sell personal information.</div>
        <div>We may disclose information as permitted or required by law, including to:</div>
        <div class="pl8">- Service providers and vendors.</div>
        <div class="pl8">- Affiliates for compliance, information security, risk management, corporate governance, and operational support.</div>
        <div class="pl8">- Regulatory authorities, licensing agencies, courts, and law-enforcement agencies.</div>
        <div class="pl8">- Attorneys, auditors, accountants, insurers, and other professional advisers.</div>
        <div class="pl8">- Authorized delegates, agents, banks, payment processors, and transaction partners, if and when financial services are offered.</div>
        <div class="pl8">- Parties involved in a merger, financing, restructuring, sale, or other corporate transaction.</div>
        <div>Services offered by other Alchemy Pay entities outside the United States are not provided by Alchemy Pay, Inc. or through this website.</div>
        <div>
          Alchemy Pay, Inc. does not currently disclose nonpublic personal information to nonaffiliated third parties for their own independent marketing purposes. If our
          information-sharing practices change in a manner that requires an opt-out right, we will provide the required notice and opt-out mechanism before engaging in that
          sharing.
        </div>

        <div class="sub-title">Your Privacy Rights</div>
        <div>
          Depending on applicable law, your state of residence, the nature of your relationship with Alchemy Pay, Inc., and the information involved, you may have rights to request
          access to, correction of, or deletion of certain personal information, or to limit certain uses or disclosures.
        </div>
        <div>
          These rights may be subject to legal and regulatory exceptions, including requirements relating to record retention, fraud prevention, transaction processing,
          investigations, and compliance obligations.
        </div>
        <div>
          To submit a privacy-related inquiry or request, contact us using the information below. We may request information reasonably necessary to verify your identity and
          process your request.
        </div>

        <div class="sub-title">Safeguarding Your Information</div>
        <div>
          We maintain physical, electronic, administrative, and procedural safeguards designed to protect personal information against unauthorized access, use, disclosure,
          alteration, loss, or destruction, consistent with applicable GLBA requirements.
        </div>
        <div>No method of transmission or storage is completely secure, and we cannot guarantee absolute security.</div>

        <div class="sub-title">Changes to This Notice</div>
        <div>
          We may update this notice to reflect changes in law, regulation, our operating status, our services, or our privacy practices. When we make changes, we will post the
          revised notice and update the “Last Updated” date.
        </div>

        <div class="sub-title">Contact Us</div>
        <div>Questions concerning this notice or our privacy practices may be directed to:</div>
        <div class="text-bold">Alchemy Pay, Inc.</div>
        <div class="text-bold">Attention: U.S. Compliance</div>
        <div>
          <span class="text-bold">Email:</span>
          <a class="link-style" href="mailto:compliance-us@alchemypay.org">compliance-us@alchemypay.org</a>
        </div>
        <div><span class="text-bold">Telephone:</span> +1 (866) 584-9768</div>
        <div><span class="text-bold">Address:</span> Suite 101, 3120 Scott Boulevard, Santa Clara, California 95054, United States</div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  data() {
    return {};
  },
  components: {
    Footer,
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
  mounted() {},
  destroyed() {},
  created() {},
};
</script>
<style lang="scss" scoped>
.pl8 {
  text-indent: 2em;
}
@media screen and (max-width: 1180px) {
  .title-content {
    height: 100px;
    padding: 31px 0 35px 20px;
    box-sizing: border-box;
    background: #fff;
  }
  .title-logo {
    width: 149px;
    // height: 24px;
    object-fit: cover;
    cursor: pointer;
  }
  .title-us {
    width: 100%;
    height: 100px;
    color: #fff;
    text-align: center;
    background: #000;
  }
  .us-text {
    font-family: "Bold";
    font-size: 24px;
    line-height: normal;
    padding-top: 30px;
  }
  .list-box {
    margin: 36px auto 0 auto;
  }
  .list-title {
    font-family: "Bold";
    font-size: 20px;
    color: #000;
    margin-left: 16px;
    margin-right: 16px;
  }
  .item-list {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 20px 16px 0 16px;
  }
  .item-row {
    width: 100%;
    display: flex;
    align-items: center;
    font-family: "Medium";
    font-size: 11px;
    color: #525868;
    border-top: 1px solid var(--1, #ccd2e2);
  }
  .Iowa {
    border-bottom: 1px solid var(--1, #ccd2e2);
  }
  .item-row div:nth-child(1) {
    width: 33.33%;
    height: 48px;
    line-height: 48px;
    border-left: 1px solid var(--1, #ccd2e2);
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .item-row div:nth-child(2) {
    width: 33.33%;
    height: 48px;
    line-height: 48px;
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .item-row div:nth-child(3) {
    width: 33.33%;
    height: 48px;
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .state-content {
    margin: 36px 16px 0 16px;
    padding-bottom: 36px;
  }
  .state-title {
    font-family: "Bold";
    font-size: 24px;
    color: #000;
    margin-bottom: 34px;
  }
  .state-text-box {
    font-size: 16px;
    color: #525868;
    font-family: "Medium";
    line-height: 40px;
  }
  .text-title {
    margin-bottom: 35px;
  }
  .sub-title {
    font-family: "Bold";
    color: #000;
    margin-top: 24px;
  }
  .text-bold {
    font-family: "Bold";
    color: #000;
  }
  .bottom-text {
    margin-top: 34px;
  }
  .link-style {
    color: #0b48e6;
  }
  .link-style:hover {
    text-decoration: none;
    border-bottom: 1.5px solid blue;
  }
}
@media (min-width: 1180px) and (max-width: 10000px) {
  .title-content {
    height: 100px;
    padding: 31px 0 35px 77px;
    box-sizing: border-box;
    background: #fff;
  }
  .title-logo {
    width: 211px;
    // height: 34px;
    object-fit: cover;
    cursor: pointer;
  }
  .title-us {
    width: 100%;
    height: 200px;
    color: #fff;
    text-align: center;
    background: #000;
  }
  .us-text {
    font-family: "Bold";
    font-size: 60px;
    line-height: normal;
    padding-top: 59px;
  }
  .list-box {
    width: 1180px;
    margin: 80px auto 0 auto;
  }
  .list-title {
    font-family: "Bold";
    font-size: 24px;
    color: #000;
  }
  .item-list {
    border: 1px solid var(--1, #ccd2e2);
    border-bottom: none;
    margin-top: 40px;
  }
  .item-row {
    display: flex;
    align-items: center;
    font-family: "Medium";
    font-size: 16px;
    color: #525868;
  }
  .item-row div:nth-child(1),
  .item-row div:nth-child(2) {
    width: 260px;
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid var(--1, #ccd2e2);
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .item-row div:nth-child(2) {
  }
  .item-row div:nth-child(3) {
    // width: 393px;
    flex: 1;
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .state-content {
    width: 1180px;
    margin: 60px auto 0 auto;
    padding-bottom: 80px;
  }
  .state-title {
    font-family: "Bold";
    font-size: 24px;
    color: #000;
    margin-bottom: 34px;
  }
  .state-text-box {
    font-size: 16px;
    color: #525868;
    font-family: "Medium";
    line-height: 40px;
  }
  .text-title {
    margin-bottom: 35px;
  }
  .sub-title {
    font-family: "Bold";
    color: #000;
    margin-top: 24px;
  }
  .text-bold {
    font-family: "Bold";
    color: #000;
  }
  .bottom-text {
    margin-top: 34px;
  }
  .link-style {
    color: #0b48e6;
  }
  .link-style:hover {
    text-decoration: none;
    border-bottom: 1.5px solid blue;
  }
}
</style>
